export default "__VITE_ASSET__5xELIYTJ__"